import {
  FETCH_PENDING_APPROVALLIST_REQUEST,
  FETCH_PENDING_APPROVALLIST_SUCCESS,
  FETCH_PENDING_APPROVALLIST_FAILURE,
} from "./PendingApprovalListActionTypes";

import api from "../../utils/Api";
import axios from 'axios';

export const fetchPendingApprovalListRequest = () => {
  return {
    type: FETCH_PENDING_APPROVALLIST_REQUEST,
  };
};

export const fetchPendingApprovalListSuccess = (pendingApprovalList) => {
  return {
    type: FETCH_PENDING_APPROVALLIST_SUCCESS,
    payload: pendingApprovalList,
  };
};

export const fetchPendingApprovalListFailure = (error) => {
  return {
    type: FETCH_PENDING_APPROVALLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchPendingApprovalList = (
  searchKey,
  sortBy,
  page,
  pendingDeletion,
  selectedList
) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "relatedparty/approvallist/fetch?search_key=" +
  searchKey +
  "&sort_by=" +
  sortBy +
  "&page=" +
  page +
  "&pendingDeletion=" +
  pendingDeletion;

  if(selectedList){
   url += "&type="+ selectedList;
  }

  return async (dispatch) => {
    dispatch(fetchPendingApprovalListRequest);
    try {
      const response = await api.get(
        url,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const responseData = response.data.data;
      const pendingApprovalList = responseData;
      dispatch(fetchPendingApprovalListSuccess(pendingApprovalList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      const errorMsg = error.message;
      dispatch(fetchPendingApprovalListFailure(errorMsg));
    }
  };
};
